var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9866 0.84375V2.57143H0.0133929V0.84375H2.98661L3.87054 2.38419e-07H8.12946L9.01339 0.84375H11.9866ZM0.857143 13.7009V3.41518H11.1429V13.7009C11.1429 14.1563 10.9687 14.558 10.6205 14.9063C10.2723 15.2545 9.87054 15.4286 9.41518 15.4286H2.58482C2.12946 15.4286 1.72768 15.2545 1.37946 14.9063C1.03125 14.558 0.857143 14.1563 0.857143 13.7009Z",
    fill: "#D12600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.033d0878d35a6527c959a8ab07be75ee.svg";
export { ForwardRef as ReactComponent };